
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSpeedHalfUp as ObiSpeedHalfUpElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-speed-half-up.js';
 
 
 

 
 export const ObiSpeedHalfUp = createComponent({
   react: React,
   tagName: 'obi-speed-half-up',
   elementClass: ObiSpeedHalfUpElement,
   events: {
     
   }
  });
 
 